export const PRODUCT_IMAGE_SOURCE_CDN_HOST = "cdn.storerouter.ai";
export const PRODUCT_IMAGE_OPTIMIZER_ROUTE_PREFIX = "/api/image-optimizer/";

export function isProductImageOptimizerFlagEnabled(
  value = process.env.NEXT_PUBLIC_USE_OPTIMIZER
): boolean {
  return value === "true" || value === "1";
}
